const tailwind = require('../tailwind')

module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "/portfolio"

  siteTitle: 'Michael Wojcik', // Navigation and Site Title
  siteTitleAlt: 'Michael Wojcik', // Alternative Site title for SEO
  siteTitleShort: 'Michael Wojcik', // short_name for manifest
  siteUrl: 'https://michaelwojcik.org', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logo.png', // Used for SEO and manifest
  siteDescription: 'Michael Wojcik is a web designer / web developer in the Raleigh-Durham, NC area. Custom, eye-catching websites tailored to your personal or business needs.',

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  // userTwitter: '@michael_wojcik', // Twitter Username
  ogSiteName: 'Michael Wojcik', // Facebook Site Name
  ogLanguage: 'en_US', // Facebook Language

  // Manifest and Progress color
  themeColor: tailwind.colors['red-dark'],
  backgroundColor: tailwind.colors.black,
}
